import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { KeypairState } from "../types/types";
import { useAppSelector } from ".";
import {
  getLocalStorageKeysInfo,
  setKeypairState,
} from "../store/reducers/keys";
import { AppDispatch } from "../store";
import useRestorePubkey from "./useRestorePubkey";
import { useWeb3Auth } from "./useWeb3Auth";

const useKeypairState = () => {
  const dispatch: AppDispatch = useDispatch();

  const { pin, encryptedPrivateKey, keypairState, loaded } = useAppSelector(
    (state) => state.keys
  );
  const { address, isProticoAuthenticated } = useWeb3Auth();
  useRestorePubkey();

  useEffect(() => {
    if (!address) return;
    dispatch(getLocalStorageKeysInfo(address));
  }, [dispatch, address]);
  useEffect(() => {
    if (!loaded) return;

    if (isProticoAuthenticated) {
      dispatch(setKeypairState(KeypairState.WAITING_KEY_AUTH));
    }
  }, [loaded, isProticoAuthenticated]);
  useEffect(() => {
    if (keypairState !== KeypairState.WAITING_KEY_AUTH) return;
    if (pin && encryptedPrivateKey)
      dispatch(setKeypairState(KeypairState.KEYPAIR_SUCCESS));
  }, [keypairState, pin, encryptedPrivateKey]);
};
export default useKeypairState;
